import { memo, useEffect, useState } from 'react'
import { setPageName } from '../../../../redux'
import { useDispatch } from 'react-redux'
import { getData } from '../../../../assets/scripts/GeneralFunctions'
import SmsTable from '../../../tabels/SmsTable'
import AddMoreButton from '../../../buttons/AddMoreButton'

function Sms() {
  const dispatch = useDispatch()
  const [lazy_load_data, setLazyLoadData] = useState({
    limit: 10,
    offset: 0,
  })
  const [sms, setSms] = useState([NaN, NaN])
  const [customerTypes, setCustomerTypes] = useState([])
  const [is_all_items_load, setAllLoad] = useState(true)

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('sms'))

      let api_result = await getData(
        'admin/sms',
        'get',
        {
          ...lazy_load_data,
        },
        true
      )
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          setSms(result_data?.sms)
          setCustomerTypes(result_data?.customer_types)
        }
      }
    }

    fetchData()
  }, [])

  return (
    <>
      <div className="flex justify-between md:py-8">
        <h1 className="text-xl font-medium my-auto dark:text-amber-50">لیست اس ام اس های ارسالی</h1>
        <div className="flex items-center gap-x-6">
          <AddMoreButton
            link={'sms'}
            title={'ارسال پیام'}
            icon={'sms'}
            customerTypes={customerTypes}
          />
        </div>
      </div>
      <div className={'md:py-8'}>
        <SmsTable
          is_all_items_load={is_all_items_load}
          sms={sms}
          setSms={setSms}
          setLazyLoadData={setLazyLoadData}
          lazy_load_data={lazy_load_data}
          setAllLoad={setAllLoad}
        />
      </div>
    </>
  )
}

export default memo(Sms)
